import React from 'react';
import notfound from '../assets/images/career/not-found.png';
import { t } from 'i18next';

export const Careers = () => {
    return (
        <section className="px-6 md:px-20 py-16 bg-gray-50">
            {/* Section Header */}
            <div className="text-center mb-14">
                <h2 className="text-4xl md:text-5xl font-extrabold text-[#1a0080] drop-shadow-sm">
                    {t('career.heading1')}
                </h2>
                <p className="text-gray-600 text-sm md:text-base mt-3 leading-relaxed max-w-xl mx-auto">
                    {t('career.heading2')}
                </p>
            </div>

            {/* Career Intro Text */}
            <p className="text-[#1a0080] md:text-lg text-center mb-12 max-w-3xl mx-auto font-medium">
                {t('career.title1')}
            </p>

            {/* Career Image */}
            <div className="flex justify-center">
                <div className="relative flex flex-col items-center group">
                    <div className="w-64 h-64 md:w-80 md:h-80 rounded-3xl overflow-hidden shadow-xl transition-transform duration-500 hover:scale-105">
                        <img
                            className="w-full h-full object-cover object-center"
                            src={notfound}
                            alt="career"
                        />
                        {/* Subtle overlay on hover */}
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-3xl"></div>
                    </div>
                    <p className="text-2xl md:text-3xl text-[#1a0080] font-bold mt-6 text-center">
                        {t('career.title2')}
                    </p>
                </div>
            </div>
        </section>
    );
};
